<template>
  <div class="modal fade" :id="modalId" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header py-3">
          <h3 class="modal-title fw-bolder">
            Sessões da recorrência
            <span class="badge badge-light-info ms-2" v-if="sessions.length">
              {{ sessions.length }} agendamento(s)
            </span>
          </h3>
          <button type="button" class="btn btn-icon btn-sm btn-active-icon-primary" @click="close">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>
        <div class="modal-body pt-2">
          <div v-if="loading" class="text-center py-10 text-muted">Carregando sessões...</div>
          <div v-else-if="!sessions.length" class="text-center py-10 text-muted">
            Nenhuma sessão encontrada.
          </div>
          <div v-else class="table-responsive">
            <table class="table table-row-dashed align-middle gs-0 gy-3">
              <thead>
                <tr class="fw-bold text-muted">
                  <th>Sessão</th>
                  <th>Data</th>
                  <th>Hora</th>
                  <th>Status</th>
                  <th>Profissional</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in sessions"
                  :key="item.id_sched"
                  :class="{ 'table-active': item.id_sched === currentSchedId }"
                >
                  <td class="fw-bolder">
                    {{ item.sched_recur_session }}/{{ item.sched_recur_total }}
                  </td>
                  <td>{{ formatDate(item.sched_date) }}</td>
                  <td>{{ item.sched_time }}</td>
                  <td>
                    <span
                      class="badge text-white"
                      :style="{ backgroundColor: statusColor(item) }"
                    >
                      {{ item.status_description || item.sched_status }}
                    </span>
                  </td>
                  <td class="text-truncate" style="max-width: 160px;">{{ item.prof_name }}</td>
                  <td class="text-end">
                    <button
                      type="button"
                      class="btn btn-sm btn-light-primary"
                      @click="viewSchedule(item)"
                    >
                      Visualizar
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '../../helpers/http';
import Alert from '../../helpers/alert';

export default {
  name: 'ModalScheduleRecurrenceSessions',
  props: {
    open: { type: Boolean, default: false },
    schedRecurId: { type: [Number, String], default: null },
    currentSchedId: { type: [Number, String], default: null },
  },
  emits: ['close', 'view-schedule'],
  data() {
    return {
      loading: false,
      sessions: [],
      statusList: [],
      modalId: `modal_schedule_recurrence_${Math.random().toString(36).slice(2, 9)}`,
    };
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
  },
  watch: {
    open(value) {
      if (value) {
        Promise.all([this.loadStatusList(), this.loadSessions()]).then(() => {
          bootstrap.Modal.getOrCreateInstance(document.getElementById(this.modalId)).show();
        });
      } else {
        const el = document.getElementById(this.modalId);
        if (el) {
          bootstrap.Modal.getInstance(el)?.hide();
        }
      }
    },
  },
  mounted() {
    this.loadStatusList();
    this.$nextTick(() => {
      const el = document.getElementById(this.modalId);
      el?.addEventListener('hidden.bs.modal', () => {
        if (this.open) {
          this.$emit('close');
        }
      });
    });
  },
  methods: {
    date: moment,
    formatDate(value) {
      return this.date(value).format('DD/MM/YYYY');
    },
    statusColor(item) {
      if (item?.sched_status_color) {
        return item.sched_status_color;
      }
      const status = this.statusList.find((s) => s.code === item?.sched_status);
      return status?.color || '#6c757d';
    },
    close() {
      this.$emit('close');
    },
    viewSchedule(schedule) {
      this.$emit('view-schedule', schedule);
      this.close();
    },
    loadStatusList() {
      if (this.statusList.length) {
        return Promise.resolve();
      }

      return http.get('/status').then((response) => {
        this.statusList = response.data || [];
      }).catch(() => {
        this.statusList = [];
      });
    },
    loadSessions() {
      if (!this.schedRecurId || !this.place?.id_place) {
        this.sessions = [];
        return Promise.resolve();
      }

      this.loading = true;
      return http
        .get(`/places/${this.place.id_place}/schedules/recurrences/${this.schedRecurId}`)
        .then((response) => {
          this.sessions = response.data || [];
        })
        .catch((e) => {
          Alert.toastError(e.response?.data ?? e);
          this.sessions = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
